<template>
  <div>
    <div v-if="attachments.length > 0" :key="attachments.length">
      <small v-t="'Uploaded files:'" />
      <div
        v-for="attachment in attachments"
        :key="'attachment-' + attachment.id"
        class="d-flex justify-space-between mt-2 mb-4"
      >
        <div>
          <div class="d-flex">
            <v-icon left>mdi-paperclip</v-icon>
            <div class="ml-2">
              <a class="link font-weight-thin" :href="attachment.href" target="_blank">
                {{ attachment.client_original_name }}
              </a>
            </div>
          </div>
        </div>
        <div>
          <v-btn @click="deleteAttachment(attachment)" icon text small :title="$t('Delete')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <FileUploader
      v-bind="$attrs"
      v-if="attachments.length < 1 || uploadNewFile"
      name="room-mixed-color-attachment"
      :key="'new-attachment' + newKey"
      :type="type"
      :type-id="typeId"
      outlined
      persistent-hint
      @change="
        newKey++;
        uploadNewFile = false;
      "
    />
    <base-btn small outlined text v-else @click="uploadNewFile = true">
      <v-icon small left>mdi-paperclip</v-icon>
      <span v-t="'Upload new file'" />
    </base-btn>
  </div>
</template>

<script>
import FileUploader from "./FileUploader";
export default {
  components: {
    FileUploader,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    typeId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      newKey: 1,
      uploadNewFile: false,
    };
  },
  computed: {
    attachments() {
      return this.$store.state.attachments.filter((attachment) => {
        if (attachment.type !== this.type) return false;
        if (attachment.type_id === null && this.typeId === null) return true;
        if (parseInt(attachment.type_id) === this.typeId) return true;
        return false;
      });
    },
  },
  methods: {
    deleteAttachment(attachment) {
      this.axios
        .delete("/attachment/" + attachment.id)
        .then((response) => {
          if (response.data.attachments)
            this.$store.commit("SET", { attachments: response.data.attachments });

          this.$store.dispatch("checkValidity");
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

